const BAND = {
    POOR: 'Poor',
    FAIR: 'Fair',
    GOOD: 'Good',
    VERY_GOOD: 'Very good',
    EXCELLENT: 'Excellent',
};
export function suggestDecision(input) {
    const r = input.score;
    const at = `CyberScore ${r.score} (${BAND[r.band]})`;
    const why = [];
    const referrals = [];
    if (r.profile?.below_minimum && r.profile.minimum_band)
        referrals.push(`${r.profile.name} needs ${BAND[r.profile.minimum_band]} or better; this is ${BAND[r.band]}.`);
    for (const f of input.forms ?? [])
        for (const b of f.blockers.filter((x) => x.effect === 'refer' || x.effect === 'decline'))
            referrals.push(`${f.insurer} ${f.product} ${b.effect === 'decline' ? 'declines' : 'refers'} on “${b.label}”${b.note ? `: ${b.note}` : ''}.`);
    if (r.provisional)
        why.push('Some required questions are still open, so the score is provisional.');
    if (referrals.length)
        return {
            outcome: 'refer',
            why: [...referrals, ...why],
            reason: `${at}. Referred: ${referrals.join(' ')}`,
            conditions: [],
        };
    const terms = (input.forms ?? []).flatMap((f) => f.blockers.filter((b) => b.effect === 'terms').map((b) => `${f.insurer} ${f.product} may narrow cover on “${b.label}”.`));
    const failed = r.kill_switches.failed;
    if (failed.length) {
        const names = failed.map((k) => k.name);
        return {
            outcome: 'accept_with_conditions',
            why: [
                `${failed.length === 1 ? 'A minimum protection is' : `${failed.length} minimum protections are`} missing: ${names.join(', ')}. Each becomes a dated condition.`,
                ...(r.kill_switches.cap !== null
                    ? [`The score is held at ${r.kill_switches.cap} until they are in place.`]
                    : []),
                ...terms,
                ...why,
            ],
            reason: `${at}. Accepted on condition that ${names.join(', ')} ${failed.length === 1 ? 'is' : 'are'} put in place.${terms.length ? ` ${terms.join(' ')}` : ''}`,
            conditions: failed.map((k) => ({
                title: `Put in place: ${k.name}`,
                control: k.control,
                weeks: k.severity === 'critical' ? 2 : 4,
            })),
        };
    }
    return {
        outcome: 'accept',
        why: ['Every minimum protection is in place.', ...(r.profile?.minimum_band ? [`It meets the ${r.profile.name} minimum of ${BAND[r.profile.minimum_band]}.`] : []), ...terms, ...why], // prettier-ignore
        reason: `${at}. Every minimum protection is in place.${terms.length ? ` ${terms.join(' ')}` : ''}`,
        conditions: [],
    };
}
//# sourceMappingURL=decision-suggestion.js.map